export const formatInr = (value?: number | null, compact = false): string => {
  const n = Number(value || 0);
  if (!Number.isFinite(n) || n === 0) return '—';
  if (compact) {
    if (n >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
    if (n >= 1e5) return `₹${(n / 1e5).toFixed(1)} L`;
  }
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(n);
};

export const formatPercent = (value?: number | null): string => {
  const n = Number(value || 0);
  if (!Number.isFinite(n)) return '—';
  return `${Math.round(n)}%`;
};

export const turnoverSourceLabel = (source?: string | null): string => {
  const map: Record<string, string> = {
    manual: 'Manual',
    gst: 'GST API',
    gst_sandbox: 'GST (sandbox)',
    indiamart: 'IndiaMART',
    observed_seller: 'Observed seller volume',
    observed_buyer: 'Observed buyer volume',
  };
  return map[String(source || '')] || source || '—';
};
